import React, { useContext } from 'react';

import { Field } from 'formik'
import { TextField } from 'formik-material-ui';

import {
    Grid,
    Typography
} from '@material-ui/core';

import { Select } from '../../../../common';

import { 
    FieldError 
} from '../../../../common';

import { CustomerRequestContext } from '../../CustomerRequestContext';
import { TabsContext } from '../TabsContext';

import { SapTableNames } from '../../../../../helpers';
 
import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    field: {
        width: '100%'
    },
}));

export const AddressForm = (props) => {
    const classes = useStyles();

    const {        
        state,
        getTableOptionsWithCode,
        getStateOptions
    } = useContext(CustomerRequestContext)

    const { values } = useContext(TabsContext);

    const { header, formSuffixName, suffixIndex } = props

    const getAddress = () => {
        const tokens = formSuffixName.split(".");
        let address = values;
        for(let i = 0; i < tokens.length - (suffixIndex !== undefined ? 1 : 0) ; i++) {            
            let token = tokens[i];
            if(token.includes("[")) token = token.split("[")[0];
            address = address[token];
            if(!address) return null;
        }                
        return suffixIndex !== undefined ? address[suffixIndex][tokens[tokens.length - 1]] : address;
    }

    const getAddressCountryId = () => {
        const address = getAddress();
        return address ? (address.countryId === "" ? "-1" : address.countryId) : "-1";
    }

    return (
        <Grid container spacing={3}>
            <Grid item xl={12} md={12} xs={12}>
                <Typography variant="subtitle1" gutterBottom>
                    {header ? header : "Address"}
                </Typography>
            </Grid>
            <Grid item xl={4} md={12} xs={12}>
                <Field
                    className={classes.field}
                    variant="outlined"
                    type="text"
                    name={`${formSuffixName}.street`}
                    label={props.formSuffixName && props.formSuffixName.indexOf("bankReferences") !== -1 ? "Street" : "Street *"}
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.street`} errors={state.errors} />
            </Grid>
            <Grid item xl={4} md={12} xs={12}>
                <Field
                    variant="outlined"
                    className={classes.field}
                    type="text"
                    name={`${formSuffixName}.city`}
                    label={props.formSuffixName && props.formSuffixName.indexOf("bankReferences") !== -1 ? "City" : "City *"}
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.city`} errors={state.errors} />
            </Grid>
            <Grid item xl={4} md={12} xs={12}>
                <Field
                    variant="outlined"
                    className={classes.field}
                    type="text"
                    name={`${formSuffixName}.zipCode`}
                    label={props.formSuffixName && props.formSuffixName.indexOf("bankReferences") !== -1 ? "Zip code" : "Zip code *"}
                    disabled={props.disabled}
                    component={TextField}
                />
                <FieldError name={`${formSuffixName}.zipCode`} errors={state.errors} />
            </Grid>
            <Grid item xl={6} md={12} xs={12}>
                <Select
                    name={`${formSuffixName}.countryId`}
                    label={props.formSuffixName && props.formSuffixName.indexOf("bankReferences") !== -1 ? "Country" : "Country *"}
                    disabled={props.disabled}
                    options={getTableOptionsWithCode(SapTableNames.Countries, values.dbType)}>
                </Select>
                <FieldError name={`${formSuffixName}.countryId`} errors={state.errors} />
            </Grid>
            <Grid item xl={6} md={12} xs={12}>
                <Select
                    name={`${formSuffixName}.stateId`}
                    label={props.formSuffixName && props.formSuffixName.indexOf("bankReferences") !== -1 ? "State" : "State *"}
                    disabled={props.disabled}
                    options={getStateOptions(getAddressCountryId(), values.dbType)}>
                </Select>
                <FieldError name={`${formSuffixName}.stateId`} errors={state.errors} />                
            </Grid>
        </Grid>
    );
}